import { DiscButton } from "./DiscButton";
import { DiscColors, DiscImageConfig, PlayPauseDiscButton } from "./helpers";
import type { ButtonHTMLAttributes } from "react";

export type DiscPlayerProps = {
  className?: string;
  colors?: DiscColors;
  image?: DiscImageConfig;
  noiseOpacity?: number;
  isPlaying?: boolean;
  onClick: () => void;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function DiscPlayer({
  className,
  colors,
  image,
  noiseOpacity = 0.5,
  isPlaying = false,
  onClick,
  ...rest
}: DiscPlayerProps) {
  return (
    <DiscButton
      className={className}
      colors={colors}
      image={image}
      noiseOpacity={noiseOpacity}
      onClick={onClick}
      {...rest}
    >
      <PlayPauseDiscButton isPlaying={isPlaying} />
    </DiscButton>
  );
}
